<template>
    <div class="devices-list__block" v-if="deviceData">
        <device-status :device="deviceData" :showLocation="showLocation"/>
        <v-layout row class="devices-list__block__title">
            <device-title :device="deviceData"></device-title>
            <v-flex class="btn-block">
                <device-favorite :device="deviceData"></device-favorite>
                <div class="d-inline-flex" v-if="deviceData.state != null && deviceData.online">
                    <v-switch
                        v-model="deviceState"
                        inset
                        dense
                        hide-details
                        class="pa-0"
                        @click="changeDeviceSwitch"
                        :loading="loading"
                        color="#FF8484"
                        :disabled="deviceData.is_action || deviceData.disabled"
                    ></v-switch>
                </div>
            </v-flex>
        </v-layout>
        <div class="vue-slider-row mt-3" v-if="!deviceData.is_action && deviceData.online">
            <div class="vue-slider-prepend">
                <span class="main-text">0%</span>
            </div>
            <div class="vue-custom-slider-container">
                <vue-slider
                    v-model="deviceData.state.value"
                    :adsorb="true"
                    :interval="1"
                    :min="0"
                    :max="100"
                    :height="16"
                    :lazy="true"
                    :disabled="loading || deviceData.disabled"
                    tooltip-formatter="{value}%"
                    tooltip="always"
                    class="vue-custom-slider"
                />
            </div>
            <div class="vue-slider-append">
                <span class="main-text">100%</span>
            </div>
        </div>
        <v-flex d-flex justify-end>
            <div v-if="deviceData.is_action && deviceData.state" class="note-row">
                {{deviceData.state.last_update.slice(0, 16)}}
            </div>
        </v-flex>
    </div>
</template>

<script>
import { LOADING_TIMEOUT } from "@/utils/constants.js";
export default {
    name: "DimmableLightingDevice",
    props: {
        device: {
            type: [Array, Object],
            default: null,
        },
        showLocation: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            deviceData: { state: null },
            deviceState: false,
            deviceStateOldValue: null,
            loading: false,
            disabledTimeout: null,
        };
    },
    created() {
        this.deviceData = this.device;
        this.deviceState = this.deviceData.state.value > 0 ? true : false;
        this.deviceStateOldValue = JSON.parse(JSON.stringify(this.deviceData.state));
    },
    beforeDestroy() {
        if (this.disabledTimeout) {
            clearTimeout(this.disabledTimeout);
        }
    },
    watch: {
        device(val) {
            if (val) {
                this.deviceData = val;
                this.loading = false;
                this.deviceState = this.deviceData.state.value > 0 ? true : false;
                if (this.disabledTimeout) {
                    clearTimeout(this.disabledTimeout);
                    this.deviceData.disabled = false;
                }
            }
        },
        "deviceData.state": {
            handler: function(val, old) {
                if (val != old && this.deviceData.state.value != this.deviceStateOldValue.value) {
                    this.deviceStateOldValue = old;
                }
            },
            deep: true,
        },
    },
    methods: {
        changeDeviceSwitch() {
            if (!this.deviceData.is_action) {
                if (this.deviceState) {
                    this.deviceData.state.value = 100;
                } else {
                    this.deviceData.state.value = 0;
                }
                this.changeDeviceValue();
            }
        },
        changeDeviceSlider() {
            if (!this.deviceData.is_action) {
                setTimeout(() => {
                    this.changeDeviceValue();
                }, 1000);
            }
        },
        changeDeviceValue() {
            this.loading = true;
            this.deviceData.disabled = true;
            if (this.disabledTimeout) {
                clearTimeout(this.disabledTimeout);
            }
            this.disabledTimeout = setTimeout(() => {
                this.deviceData.disabled = false;
                this.loading = false;
                this.deviceData.state = this.deviceStateOldValue;
            }, LOADING_TIMEOUT);
            this.$http.put('/devices/guest/device/' + this.deviceData.uid + '/state', {
                value: this.deviceData.state.value
            })
                .catch((error) => {
                    if (this.disabledTimeout) {
                        clearTimeout(this.disabledTimeout);
                    }
                    this.deviceData.disabled = false;
                    this.deviceData.state = this.deviceStateOldValue;
                    this.loading = false;
                    console.log(error);
                });
        },
    },
}
</script>
